import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NarzedziaState, NarzedziaWykonawcze } from './narzedzia.reducer';
import { NARZEDZIA_WYKONAWCZE_ID } from './narzedzia.const';
import { selectCzyWidokToNarzedzia } from '../lewy-panel-widok/lewy-panel-widok.selectors';

export const selectModulMapowyState = createFeatureSelector<any>('modulMapowy');

export const selectNarzedziaState = createSelector(
  selectModulMapowyState,
  (modulState) => modulState ? modulState.narzedzia : undefined
);

export const selectAktywneNarzedzieId = createSelector(
  selectNarzedziaState,
  (state: NarzedziaState | undefined) => state?.aktywneNarzedzieId
);

export const selectAktualneNarzedzieWykonawcze = createSelector(
  selectNarzedziaState,
  (state: NarzedziaState | undefined): NarzedziaWykonawcze | undefined => {
    if (!state || !state.aktywneNarzedzieId) {
      return undefined;
    }
    return state.narzedziaWykonawcze.find(n => n.id === state.aktywneNarzedzieId);
  }
);
export const selectCzyPomiarJestAktywny = createSelector(
  selectAktywneNarzedzieId,
  (aktywneId) => aktywneId === NARZEDZIA_WYKONAWCZE_ID.DOKONAJ_POMIARU
);


export const selectCzyZablokowacOperacje = createSelector(
  selectAktywneNarzedzieId,
  selectCzyWidokToNarzedzia,
  (aktywneId, czyWidokNarzedzia) => {
    return aktywneId === NARZEDZIA_WYKONAWCZE_ID.DOKONAJ_POMIARU && czyWidokNarzedzia;
  }
);
